

































































import { Component, Mixins } from 'vue-property-decorator';
import { LoginModel } from '@/interfaces/registration/models/LoginModel';
import { ListOption } from '@/interfaces/registration/ListOption';
import api from '@/api/registration';
import AvatarPicker from './AvatarPicker.vue';
import RegistrationPanelMixing from '@/mixins/registration/RegistrationPanelMixin';
import FieldMixin from '@/mixins/registration/FieldMixin';
import SocialAccountLogin from '@/components/registration/common/SocialAccountLogin.vue';
import PasswordFieldValidator from '@/components/registration/common/validation/PasswordFieldValidator.vue';
import EqualFieldsValidator from '@/components/registration/common/validation/EqualFieldsValidator.vue';
import UserAnonymity from '@/components/registration/common/user-anonymity/UserAnonymity.vue';

import { namespace } from 'vuex-class';
const utils = namespace('utils');
  @Component(
    {
      components: {
        AvatarPicker,
        SocialAccountLogin,
        PasswordFieldValidator,
        EqualFieldsValidator,
        UserAnonymity
      }
    }
  )
export default class LoginPanel extends Mixins(FieldMixin, RegistrationPanelMixing) {
    public model: LoginModel = { userAnonymity: false };
    public stopRegistration = false;
    public lastEmailChecked: string | undefined;
    public privacyText = '';
    @utils.State
    public privacyLevels!: Array<ListOption>;

    public anonymousTooltip =
      {
        content: 'Anonymous profiles do not receive content notifications automatically. To choose to receive them, please tick the box.',
        classes: 'v-tooltip',
        placement: 'top',
        container: 'body',
        trigger: 'hover click'
      };

    mounted () {
      this.$data.model = this.getPanelData('login');
      this.emailEntered();
      this.privacyText = this.getCustomHelpText('ProfilePrivacy') || 'What privacy level do you want for your profile?';
      window.scrollTo(0, 0);
    }

    public savePanelData (): Promise<boolean> {
      this.saveRegistrationModel({ data: this.model, model: 'login' });
      return Promise.resolve(true);
    }

    public accountCreationRequired (): boolean {
      // Need to add check for existing user and attendee registration
      return true;
    }

    public emailEntered (): void {
      if (this.lastEmailChecked !== this.model.email) {
        this.lastEmailChecked = this.model.email;
        api.post('/account/register/existingaccountwithemail', { email: this.model.email })
          .then(response => {
            if (response.data.AccountExists === true) {
              this.stopRegistration = true;
              this.pauseNavigation();
            } else {
              this.continueRegistration();
            }
          });
      }
    }

    public continueRegistration (): void {
      this.stopRegistration = false;
      this.resumeNavigation();
    }

    get loginTitle (): string {
      switch (this.registrationData.registrationType) {
        case 'AttendeeRegistration': {
          if (this.registrationData.registration.status === 'Completed') {
            return 'Update Your Registration for ' + this.registrationData.registration.event?.name;
          } else {
            return 'Complete Your Registration for ' + this.registrationData.registration.event?.name;
          }
        }
        case 'ExhibitorRegistration':
        case 'OrganizationMembership': {
          return 'Create Your Personal ' + this.registrationData.community?.name + ' Account';
        }
        case 'VolunteerRegistration': {
          return this.registrationData.volunteerHeaderText;
        }
        case 'VolunteerTeamLeaderInvite': {
          return this.registrationData.event?.name + ' Team Leader Registration';
        }
        case 'ClaimEcourse': {
          return 'Claim Your Course';
        }
        // IndividualMembership, CompleteProfile, OrganizationAdminInvite, default
        default: {
          return 'Create Your ' + this.registrationData.community?.name + ' Account';
        }
      }
    }

    get loginSubtitle (): string {
      switch (this.registrationData.registrationType) {
        case 'AttendeeRegistration':
          return 'Fill in your information to complete your event registration and meal choices. This information will also be used to provide you personalized session and exhibitor recommendations.';
        default:
          return 'Filling out your profile completely helps us recommend information to you and makes valuable connections.';
      }
    }

    get loginUrl (): string {
      return '/account/login?returnUrl=' + window.location.pathname;
    }
}
